import * as Location from 'expo-location';
import { MapLocation } from '../models/MapModels';
import { withTimeout } from './withTimeout';

const LOCATION_TIMEOUT_MS = 15000;

const toMapLocation = (location?: Location.LocationObject | null): MapLocation | undefined => {
  if (!location) {
    return undefined;
  }

  const lat = Number(location.coords?.latitude);
  const lng = Number(location.coords?.longitude);
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
    return undefined;
  }

  return { lat, lng, isDefault: false };
};

export const getForegroundLocationWithoutPrompt = async (fallbackLocation: MapLocation): Promise<MapLocation> => {
  try {
    const permission = await withTimeout(Location.getForegroundPermissionsAsync(), 3000);
    if (!permission.granted) {
      return { ...fallbackLocation };
    }

    const lastKnown = toMapLocation(
      await withTimeout(Location.getLastKnownPositionAsync({ maxAge: 300000 }), 3000),
    );
    if (lastKnown) {
      return lastKnown;
    }

    const currentLocation = toMapLocation(
      await withTimeout(
        Location.getCurrentPositionAsync({
          accuracy: Location.Accuracy.Balanced,
          mayShowUserSettingsDialog: true,
        }),
        LOCATION_TIMEOUT_MS,
      ),
    );
    if (currentLocation) {
      return currentLocation;
    }
  } catch {
    // Fallback behavior is expected when location access is unavailable.
  }

  return { ...fallbackLocation };
};

